export { default } from './ChatFooter';
